import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { H2 } from '@decisiv/ui-components';
import iconix from '@decisiv/iconix';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';

import { NoResultDescription, CenteredContainer } from './style';

const SELECT_ALL = 'all';

const narrowedBy = (values) =>
  values.filter((value) => value !== SELECT_ALL).length > 0;

export default function NoLocationsFound({
  filterSearch,
  filterOem = [],
  filterDealerType = [],
  showsConfiguredLocations = false,
}) {
  const hasQuery = !isEmpty(trim(filterSearch));
  const hasFilters = narrowedBy(filterOem) || narrowedBy(filterDealerType);

  // Nothing was searched or filtered, so the list is empty because the
  // integration has no locations — not because a search came back empty. Only
  // the detail page can say this; the add-location modal lists SRM accounts
  // matching a search, where "none configured" would be the wrong sentence.
  if (showsConfiguredLocations && !hasQuery && !hasFilters) {
    return (
      <CenteredContainer
        flexDirection="column"
        alignItems="center"
        paddingY={2}
      >
        <iconix.MapPin height={32} width={32} />
        <H2 marginTop={1} marginBottom={1}>
          <Trans>No locations configured</Trans>
        </H2>
        <NoResultDescription shade={1}>
          <Trans>
            This integration hasn&rsquo;t been configured for any location.
          </Trans>
        </NoResultDescription>
      </CenteredContainer>
    );
  }

  return (
    <CenteredContainer flexDirection="column" alignItems="center" paddingY={2}>
      <iconix.Search height={32} width={32} />
      <H2 marginTop={1} marginBottom={1}>
        <Trans>No matches for &ldquo;{filterSearch}&rdquo;</Trans>
      </H2>
      <NoResultDescription shade={1}>
        {hasFilters ? (
          <Trans>
            Try removing or editing some of your filters to expand your search.
          </Trans>
        ) : (
          <Trans>
            Check that all words are spelled correctly or search by a different
            value.
          </Trans>
        )}
      </NoResultDescription>
    </CenteredContainer>
  );
}

NoLocationsFound.propTypes = {
  filterSearch: PropTypes.string.isRequired,
  filterOem: PropTypes.arrayOf(PropTypes.string),
  filterDealerType: PropTypes.arrayOf(PropTypes.string),
  // The detail page lists locations this integration is configured for; an
  // empty unfiltered list there means "none yet".
  showsConfiguredLocations: PropTypes.bool,
};
